import script from "./AlertPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertPop.vue?vue&type=script&setup=true&lang=ts"

import "./AlertPop.vue?vue&type=style&index=0&id=1ca5c6ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca5c6ba"]])

export default __exports__